exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dpsdatatable-component{border:0}.dataTable{width:100%;font-size:.75em;border:1px solid grey;border-spacing:0}.dataTable td,th{border:1px solid grey;padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/DpsDataTable.css
// module id = 138
// module chunks = 0